import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const ProofofPlay = {
  name: 'proofofPlay',
  state: {
    data: {},
    loading: false,
    dsos: [],
    error: '',
    success: '',
  },
  reducers: {
    createRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        dsos: [],
        success: '',
      };
    },

    createSucceeded(state, payload) {
        const data = payload?.data?.proofFiles;
      return {
        ...state,
        data: data,
        loading: false,
        error: '',
        success: 'Advertiser Favourited successfully.',
      };
    },

    createSucceededFiles(state, payload) {
        const data = payload?.data;
      return {
        ...state,
        data: data?.data,
        dsos: payload?.data?.dsos || [],
        loading: false,
        error: '',
        success: 'Advertiser Favourited successfully.',
      };
    },

    createFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
        success: '',
      };
    },

    clearMessages(state) {
      return {
        ...state,
        error: '',
        success: '',
      };
    },
  },
  effects: (dispatch) => ({
    async UploadProof({ camp_id, proof, adv_id}) {
      try {
        const user = JSON.parse(localStorage.getItem('userInfo'));
        const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
        const org_id = onBehalf ? user?.org_id : null;
        const payload = {
          user_id: user?.id,
          camp_id: camp_id,
          proofFiles: proof,
          adv_id: adv_id,
          onBehalf: onBehalf,
          org_id: org_id,
        };

        this.createRequested();

        const response = await http.post('savvy/proof-of-play', payload);
        this.createSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Proof of Play uploaded successfully.',
            show: true,
          },
        });
      } catch (error) {
        const errorMessage = responseMessageHandler.show(error.message);
        this.createFailed(errorMessage);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: errorMessage,
            show: true,
          },
        });
      }
    },

    async getFiles({ camp_id }) {
      try {
        const user = JSON.parse(localStorage.getItem('userInfo'));

        if (!user?.id || !camp_id) {
          return;
        }

        this.createRequested();

        const response = await http.get(`savvy/proof-of-play/?user_id=${user?.id}&camp_id=${camp_id}`);
        this.createSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Proof of Play uploaded successfully.',
            show: true,
          },
        });
      } catch (error) {
        // Don't show error toast for getFiles - it's optional and might not exist
        const errorMessage = responseMessageHandler.show(error.message);
        this.createFailed(errorMessage);
        // Only show error if it's a server error (5xx), not client errors (4xx) which are expected
        if (error?.response?.status >= 500) {
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'error',
              message: errorMessage,
              show: true,
            },
          });
        }
      }
    },

    async getAllCampaignFiles(camp_id) {
      try {
        this.createRequested();

        const response = await http.get(`savvy/proof-of-play/${camp_id}`);
        this.createSucceededFiles(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Proof of Play uploaded successfully.',
            show: true,
          },
        });
      } catch (error) {
        const errorMessage = responseMessageHandler.show(error.message);
        this.createFailed(errorMessage);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: errorMessage,
            show: true,
          },
        });
      }
    },
    async changeRequestStatus({user_id, camp_id, adv_id}){
        try {
          const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
          const user = JSON.parse(localStorage.getItem('userInfo'));
          const id = user?.id;
            await http.put(`savvy/proof-of-play/${camp_id}`, { user_id, adv_id, onBehalf, id });
            const newResponse = await this.getAllCampaignFiles(camp_id);
            this.createSucceededFiles(newResponse.data);
        } catch (error) {
            const errorMessage = responseMessageHandler.show(error.message);
            this.createFailed(errorMessage);
        }
    },
    async clearStateMessages() {
      this.clearMessages();
    },
  }),
};

export default ProofofPlay;

